export default "__VITE_ASSET__CIq3s7Og__"